var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PubPage',{attrs:{"showProject":""},on:{"changeProject":_vm.changeProject}},[_c('BasicTable',{attrs:{"columns":_vm.columns,"bordered":"","dataSource":_vm.list,"scroll":{ x: 1000 },"loading":_vm.loading,"boxShadow":"","pagination":{
      current: _vm.form.paging.page,
      pageSize: _vm.form.paging.limit,
      total: _vm.pageTotal,
    }},on:{"searchBack":_vm.searchBack,"pagesChange":_vm.pagesChange},scopedSlots:_vm._u([{key:"index",fn:function(ref){
    var index = ref.index;
return [_vm._v(" "+_vm._s(index + 1)+" ")]}},{key:"picture",fn:function(ref){
    var record = ref.record;
return [_c('BigImg',{attrs:{"url":record.identifyImage}})]}},{key:"syncStatus",fn:function(ref){
    var record = ref.record;
return [_c('div',{style:({
          display: 'flex',
          'align-items': 'center',
          'justify-content': 'center',
        })},[_c('PubStatus',{attrs:{"status":record.syncStatus,"type":"SYNC_STATUS"}}),(record.syncStatus == '1' && record.errorMsg)?_c('a-popover',{attrs:{"title":"异常原因"}},[_c('template',{slot:"content"},[_vm._v(" "+_vm._s(record.errorMsg)+" ")]),_c('a-icon',{style:({ 'margin-left': '5px' }),attrs:{"type":"question-circle","theme":"twoTone","two-tone-color":"#eb2f96"}})],2):_vm._e()],1)]}},{key:"place",fn:function(ref){
        var record = ref.record;
return [_c('PubStatus',{attrs:{"status":record.place,"type":"FACE_DEVICE_PLACE"}})]}},{key:"trafficDirection",fn:function(ref){
        var record = ref.record;
return [_vm._v(" "+_vm._s(_vm._f("trafficDirectionFilter")(record.trafficDirection))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }